import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DocumentService } from '../../../documents/documents.service';
import { saveAs } from 'file-saver';
import { SharedModule } from '../../shared.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-material-pdf-viewer',
  templateUrl: './material-pdf-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[
    SharedModule,
    PdfViewerModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatToolbarModule,
    MatTooltipModule,
  ]
})
export class MaterialPdfViewerComponent implements OnInit {
  src: any;
  numberOfPages?: number;
  pageNumber = 1;
  zoomLevel = 1;
  private _fileId?: string;
  _width: any;
  _height: any;
  isDragging?: boolean;
  filePreviewTitle?: string;

  constructor(private _documentsService: DocumentService) {}

  @Input() set fileId(value: string) {
    this._fileId = value;
    this._documentsService.getDownloadUrl(value).then(b => {
      this.src = b;
    });
  }

  @Input() set width(value: any) {
    this._width = value;
  }

  @Input() set height(value: any) {
    this._height = value;
  }

  @Input() set title(t: string) {
    this.filePreviewTitle = t;
  }

  ngOnInit() {
    this.pageNumber = 1;
  }

  pdfRendered($event: any) {
    this.numberOfPages = $event.numPages;
  }

  download() {
    this._documentsService.getDownloadUrl(this._fileId || '').then(f => {
      saveAs(f, `${this._fileId}.pdf`);
    });
  }
  onDrag(event: MouseEvent, pdfViewer: any) {
    if (this.isDragging) {
      const x = pdfViewer.element.nativeElement.children[0].scrollLeft - event.movementX;
      const y = pdfViewer.element.nativeElement.children[0].scrollTop - event.movementY;
      pdfViewer.element.nativeElement.children[0].scrollTo(x, y);
      pdfViewer.element.nativeElement.children[0].setAttribute('style', 'cursor: grab');
    }
  }

  onDragStarted() {
    this.isDragging = true;
  }
  onDragEnded() {
    this.isDragging = false;
  }
}
